import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios'
import { MicroSite } from '../Microsite.types'
import { apiConfig } from '../../config/api/apiConfig'

export const getPropertyMicroSite = async (
    axiosInstance: AxiosInstance,
    slug: string,
    config: AxiosRequestConfig = {}
): Promise<MicroSite> => {
    config = {
        ...config,
        maxRedirects: 0
    }

    const {
        data: { data: propertyMicroSite }
    } = await axiosInstance.get<AxiosResponse<MicroSite>>(
        apiConfig.propertyMicroSite.get.replace('{slug}', slug),
        config
    )

    return propertyMicroSite
}
